<template>
  <div class="empty" ref="empty" @mousemove="moveCard($event)">
    <div class="empty__content">
      <div class="empty__graphics" :style="{
        transform: `rotateY(${x}deg) rotateX(${y}deg)`,
      }">
        <img class="empty__image empty__image--1" src="../assets/icons/default/Background.svg" alt="" />
        <img class="empty__image empty__image--2" src="../assets/icons/default/back_page.svg" alt="" />
        <img v-if="type === 'users' || type === 'customers'" class="empty__image empty__image--3"
          src="../assets/icons/default/front_page_customers.svg" alt="" />
        <img v-if="type === 'notifications' || type === 'authLogs'" class="empty__image empty__image--3"
          src="../assets/icons/default/empty_layout.svg" alt="" />
        <img v-else-if="type === 'teams'" class="empty__image empty__image--3"
          src="../assets/icons/default/no_team_selected.svg" alt="" />
        <img v-else-if="type === 'models'" class="empty__image empty__image--3"
          src="../assets/icons/default/front_page_models.svg" alt="" />
        <img v-else-if="type === 'policies'" class="empty__image empty__image--3"
          src="../assets/icons/default/front_page_policies.svg" alt="" />
        <img v-else-if="
          type === 'potential-policies' ||
          type === 'potential-policies-dashboard' ||
          type === 'potential-policies-table' ||
          type === 'leads' ||
          type === 'customer-leads'
        " class="empty__image empty__image--3" src="../assets/icons/default/front_page_policies.svg" alt="" />
        <img v-else-if="type === 'reports' || type === 'policiesList'" class="empty__image empty__image--3"
          src="../assets/icons/default/front_page_report.svg" alt="" />
        <!-- <img
          v-else-if="type === 'pendencies'"
          class="empty__image empty__image--3"
          src="../assets/icons/default/no_pendencies_icon.svg"
          alt=""
        /> -->
        <img v-else-if="type === 'pendencies'" class="empty__image empty__image--3"
          src="../assets/icons/default/no_pendencies_icon.svg" alt="" />
        <img v-else-if="type === 'notes'" class="empty__image empty__image--3"
          src="../assets/icons/default/no_notes_icon.svg" alt="" />
        <img v-else-if="type === 'calls'" class="empty__image empty__image--3"
          src="../assets/icons/default/no_calls_icon.svg" alt="" />
        <div class="empty__active" ref="active"></div>
      </div>



      <div class="empty__title" v-if="type === 'users'">
        {{ $t(`noData.${"noUsersMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'policy-emails'">
        {{ $t(`noData.${"noPolicyEmails"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'teams'">
        {{ $t(`noData.${"noSelectedTeamMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'customers'">
        {{ $t(`noData.${"noCustomersMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'policies'">
        {{ $t(`noData.${"noPoliciesMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="
        type === 'potential-policies' ||
        type === 'potential-policies-dashboard' ||
        type === 'potential-policies-table'">
        {{ $t(`noData.${"noPotentialPolicyMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'leads' || type === 'customer-leads'">
        {{ $t(`noData.${"noLeadsMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'models'">
        {{ $t(`noData.${"noModelsMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'reports'">
        {{ $t(`noData.${"noReportsMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'policiesList'">
        {{ $t(`noData.${"noPoliciesMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'pendencies' || type === 'dashboard-pendencies'">
        {{ $t(`noData.${"noPendencyMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'offers'">
        {{ $t(`noData.${"noOffersMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'notes'">
        {{ $t(`noData.${"noNotesMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'calls'">
        {{ $t(`noData.${"noCallsMessage"}`) }}
      </div>
      <div class="empty__title" v-else-if="type === 'no-permission'">
        {{ $t(`noData.${"noPermissionMessage"}`) }}
      </div>


      <div class="empty__title" v-else-if="type === 'notifications'">
        {{ $t(`noData.${"noNotifications"}`) }}
      </div>

      <div class="empty__title" v-else-if="type === 'authLogs'">
        {{ $t(`noData.${"noAuthLogs"}`) }}
      </div>

      <div class="empty__title" v-else-if="type === 'mandates'">
        {{ $t(`noData.${"noMandatesMessage"}`) }}
      </div>


      <button type="button" class="empty__button button button--default button--shadow"
        v-if="type === 'users' && canCreateUser" @click="showAddUserModal">
        {{ $t(`noData.${"addNewUserButton"}`) }}
      </button>
      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'customers' && canCreateCustomer" @click="openCustomerModal()">
        {{ $t(`noData.${"addNewCustomerButton"}`) }}
      </button>
      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'policies' && canCreatePolicy" @click="showAddPolicyModal">
        {{ $t(`noData.${"addNewPolicyButton"}`) }}
      </button>


      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'leads' && canCreateCustomer" @click="showCustomerLeadModal">
        {{ $t(`noData.${"addNewLeadButton"}`) }}
      </button>

      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'offers' && canCreateOffer" @click="showAddOfferModal">
        {{ $t(`noData.${"addNewOfferButton"}`) }}
      </button>
      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'potential-policies' && canCreatePotentialPolicy" @click="showAddPotentialPolicyModal">
        {{ $t(`noData.${"addNewPotentialPolicy"}`) }}
      </button>

      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'potential-policies-dashboard' && canCreatePotentialPolicy"
        @click="showSearchPotentialCustomerModal">
        {{ $t(`noData.${"addNewPotentialPolicy"}`) }}
      </button>
      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'models' && canCreateModel" @click="showAddModelModal">
        {{ $t(`noData.${"addNewModelButton"}`) }}
      </button>

      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'pendencies' && canCreatePendency" @click="showAddPendencyModal">
        {{ $t(`noData.${"addNewPendencyButton"}`) }}
      </button>

      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'notes' && canCreateNote" @click="showAddNotesModal">
        {{ $t(`noData.${"addNewNoteButton"}`) }}
      </button>

      <button type="button" class="empty__button button button--default button--shadow"
        v-else-if="type === 'calls' && canCreateCall" @click="showAddCallsModal">
        {{ $t(`noData.${"addNewCallButton"}`) }}
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

defineProps({
  type: {
    required: true,
    type: String,
  },
});

const store = useStore();

const x = ref(0);
const y = ref(0);

// Template refs
const empty = ref(null);
const active = ref(null);

// Permission checks for each action type
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);

const canCreateUser = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("user_create");
  return teams.length > 0;
});

const canCreateCustomer = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("customer_create");
  return teams.length > 0;
});

const canCreatePolicy = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("policy_create");
  return teams.length > 0;
});

const canCreateOffer = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("customer_policy_offer_create");
  return teams.length > 0;
});

const canCreatePotentialPolicy = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("potential_policy_create");
  return teams.length > 0;
});

const canCreateModel = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("model_create");
  return teams.length > 0;
});

const canCreatePendency = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("pendency_create");
  return teams.length > 0;
});

const canCreateNote = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("note_create");
  return teams.length > 0;
});

const canCreateCall = computed(() => {
  if (isSuperAdmin.value) return true;
  const teams = store.getters.getTeamsWithPermission("call_create");
  return teams.length > 0;
});

const moveCard = (event) => {
  if (empty.value && event.target === active.value) {
    x.value =
      (empty.value.clientWidth / 2 -
        (event.clientX - (window.innerWidth - empty.value.clientWidth))) /
      30;
    y.value =
      (empty.value.clientHeight / 2 -
        (event.clientY - (window.innerHeight - empty.value.clientHeight))) /
      25;
  }
  return;
};

const openCustomerModal = () => {
  if (!canCreateCustomer.value) return;
  store.commit("setIsAddingCustomer", true);
  store.commit("setShowAddCustomerModal", true);
};

const showAddUserModal = () => {
  if (!canCreateUser.value) return;
  store.commit("setShowAddUserModal", true);
};

const showAddPolicyModal = () => {
  if (!canCreatePolicy.value) return;
  store.commit("setShowAddPolicyModal", true);
};

const showCustomerLeadModal = () => {
  if (!canCreateCustomer.value) return;
  store.commit("setShowCustomerLeadModal", true);
};

const showAddOfferModal = () => {
  if (!canCreateOffer.value) return;
  store.commit("setOfferToEdit", null);
  store.commit("setShowAddOfferModal", true);
};

const showAddPotentialPolicyModal = () => {
  if (!canCreatePotentialPolicy.value) return;
  store.commit("setShowAddPotentialPolicyModal", true);
};

const showSearchPotentialCustomerModal = () => {
  if (!canCreatePotentialPolicy.value) return;
  store.commit("setShowSearchPotentialCustomerModal", true);
};

const showAddModelModal = () => {
  if (!canCreateModel.value) return;
  store.commit("setShowAddModelModal", true);
};

const showAddPendencyModal = () => {
  if (!canCreatePendency.value) return;
  store.commit("setShowAddPendencyModal", true);
};

const showAddNotesModal = () => {
  if (!canCreateNote.value) return;
  store.commit("setShowAddNotesModal", true);
};

const showAddCallsModal = () => {
  if (!canCreateCall.value) return;
  store.commit("setShowAddCallsModal", true);
};
</script>

<style scoped lang="scss">
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  height: 72vh;

  &__title {
    max-width: 310px;
    text-align: center;
    color: var(--text-2);
    font-size: var(--medium);
    line-height: 23px;
    margin: 35px 0 80px 0;
  }

  &__graphics {
    transform-style: preserve-3d;
    position: relative;

    &:hover {
      .empty__image--2 {
        transform: translate(-50%, -50%) translateZ(150px) scale(1.1);
      }

      .empty__image--3 {
        transform: translate(calc(-50% + 40px), -50%) translateZ(250px) scale(1.1) rotate(20deg);
      }
    }
  }

  &__image {
    position: absolute;
    left: 50%;
    top: 50%;
    transition: transform 0.2s ease-in-out;

    &--1 {
      width: 285px;
      position: static;
    }

    &--2 {
      width: 130px;
      transform: translate(-50%, -50%);
    }

    &--3 {
      width: 115px;
      top: 30px;
      transform: translate(calc(-50% + 20px), -50%);
    }
  }

  &__active {
    position: absolute;
    width: calc(100% + 200px);
    height: calc(100% + 200px);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) translateZ(300px);
  }

  &__button {
    margin: auto;
    padding: 0 20px;
    border-radius: var(--radius-1);
  }
}
</style>
